import React, { useState, useEffect } from "react";
import Banner from '../../components/Banner';
import ChoosingUs from "../../components/ChoosingUs";
import ServicesHome from "../../components/ServicesHome";
import CaseStudy from "../../components/CaseStudy";
import Real from "../../components/Real";
import Footer from "../../components/Footer";
import AboutUsHome from "../../components/AboutUsHome";
import { useLocation } from "react-router-dom";
import whatsappIcon from '../../assets/home/whatsapp.png';

const Home = () => {
  const location = useLocation();
  const [showOptions, setShowOptions] = useState(false);

  // Handle scroll to section on page load if there's a hash in the URL
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1); // Remove the # character
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  // WhatsApp button click handlers
  const handleBaleendahClick = () => {
    window.open('https://wa.me/6281220209068', '_blank');
    setShowOptions(false);
  };

  const handleArjasariClick = () => {
    window.open('https://wa.me/6282324332024', '_blank');
    setShowOptions(false);
  };

  const handleLembangClick = () => {
    window.open('https://wa.me/6281119192020', '_blank');
    setShowOptions(false);
  };

  return (
    <>
      {/* Banner Section */}
      <section id="banner-section">
        <Banner />
      </section>

      {/* About Us Section */}
      <section id="about-section">
        <AboutUsHome />
      </section>

      {/* Why Choosing Us Section */}
      <section id="choosing-section">
        <ChoosingUs />
      </section>
      
      {/* Services Section */}
      <section id="services-section">
        <ServicesHome />
      </section>

      {/* Case Study Section */}
      <section id="case-study-section">
        <CaseStudy />
      </section>

      {/* Real Section */}
      <section id="real-section">
        <Real />
      </section>

      {/* Footer Section */}
      <section id="footer-section">
        <Footer />
      </section>

      {/* WhatsApp Floating Button with Location Options */}
      <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
        {/* Location Options */}
        {showOptions && (
          <div 
            style={{
              position: 'absolute',
              bottom: '75px',
              right: '0',
              backgroundColor: 'white',
              borderRadius: '12px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              padding: '10px',
              width: '220px',
            }}
          >
            {/* Baleendah Option */}
            <div
              onClick={handleBaleendahClick}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px',
                borderRadius: '8px',
                cursor: 'pointer',
                marginBottom: '8px',
                transition: 'background-color 0.2s ease',
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <div 
                style={{ 
                  width: '36px', 
                  height: '36px', 
                  backgroundColor: '#25D366', 
                  borderRadius: '50%', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  marginRight: '10px'
                }}
              >
                <img 
                  src={whatsappIcon} 
                  alt="WhatsApp" 
                  style={{ width: '30px', height: '30px' }} 
                />
              </div>
              <div>
                <div style={{ fontWeight: 'bold', fontSize: '14px' }}>Baleendah</div>
                <div style={{ fontSize: '12px', color: '#666' }}>(62) 812-2020-9068</div>
              </div>
            </div>
            
            {/* Arjasari Option */}
            <div
              onClick={handleArjasariClick}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease',
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <div 
                style={{ 
                  width: '36px', 
                  height: '36px', 
                  backgroundColor: '#25D366', 
                  borderRadius: '50%', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  marginRight: '10px'
                }}
              >
                <img 
                  src={whatsappIcon} 
                  alt="WhatsApp" 
                  style={{ width: '30px', height: '30px' }} 
                />
              </div>
              <div>
                <div style={{ fontWeight: 'bold', fontSize: '14px' }}>Arjasari</div>
                <div style={{ fontSize: '12px', color: '#666' }}>(62) 823-2433-2024</div>
              </div>
            </div>
            
            {/* Lembang Option */}
            <div
              onClick={handleLembangClick}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease',
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <div 
                style={{ 
                  width: '36px', 
                  height: '36px', 
                  backgroundColor: '#25D366', 
                  borderRadius: '50%', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  marginRight: '10px'
                }}
              >
                <img 
                  src={whatsappIcon} 
                  alt="WhatsApp" 
                  style={{ width: '30px', height: '30px' }} 
                />
              </div>
              <div>
                <div style={{ fontWeight: 'bold', fontSize: '14px' }}>Lembang</div>
                <div style={{ fontSize: '12px', color: '#666' }}>(62) 811-1919-2020</div>
              </div>
            </div>
          </div>
        )}
        
        {/* Main WhatsApp Button */}
        <div 
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            marginBottom: '10px',
            marginRight: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'transform 0.3s ease',
          }}
          onClick={() => setShowOptions(!showOptions)}
          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          <img 
            src={whatsappIcon} 
            alt="Chat on WhatsApp" 
            style={{
              width: '60px',
              height: '60px',
            }} 
          />
        </div>
      </div>
    </>
  );
};

export default Home;